var _g, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgMegaphone(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#megaphone_svg__clip0_1162_30346)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.899 4.966l1.506-1.506a.703.703 0 10-.994-.995l-1.507 1.507a.703.703 0 10.995.994zM22.167 8.284h-1.506a.703.703 0 000 1.407h1.506a.703.703 0 000-1.407zM13.883 2.912a.703.703 0 00.703-.703V.703a.703.703 0 00-1.406 0V2.21c0 .389.315.703.703.703z",
    fill: "#597EF7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.336 17.528a.703.703 0 000 .994l3.012 3.013c.275.274.72.274.994 0l1.179-1.178-4.007-4.007-1.178 1.178zM13.51 18.096l-4.938 2.323 3.375 3.375c.275.275.72.275.994 0l2.636-2.636a.703.703 0 000-.994l-2.068-2.068zM10.614 2.465a.703.703 0 00-1.133.198L3.508 15.355l4.007 4.007 12.692-5.973a.703.703 0 00.198-1.133l-9.79-9.79z",
    fill: "#FAAD14"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "megaphone_svg__clip0_1162_30346"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h24v24H0z"
  })))));
}

export default __webpack_public_path__ + "./fonts/megaphone.8f246d61932292c6277580e2a8450e85.svg";
export { SvgMegaphone as ReactComponent };